<template>
  <header class="navbar navbar-expand bg-white border-bottom sticky-top" style="z-index: 2100">
    <div class="container-fluid">

      <!-- ЛЕВАЯ ЗОНА: логотип -->
      <RouterLink class="navbar-brand d-flex align-items-center me-3" to="/">
        <img
          src="/assets/logo_MAG.png"
          srcset="/assets/logo_MAG.png 1x, /assets/logo_MAG@2x.png 2x"
          alt="МАГ ГРУП"
          class="brand-logo me-2"
          height="32"
        />
      </RouterLink>

      <!-- ВЫБОР ГОРОДА + ПОГОДА -->
      <div class="d-flex align-items-center gap-3 me-4">
        <!-- Город: показываем переключатель только если городов > 1 -->
        <div v-if="userCities.length > 1" class="dropdown d-none d-sm-block">
          <button
            ref="cityBtn"
            class="btn btn-sm btn-link text-dark text-decoration-none d-inline-flex align-items-center gap-1"
            data-bs-toggle="dropdown"
            type="button"
          >
            <i class="bi bi-geo-alt-fill text-primary"></i>
            <span>{{ cityName || 'Выбрать город' }}</span>
            <i class="bi bi-caret-down-fill small"></i>
          </button>
          <ul class="dropdown-menu shadow-sm">
            <li
              v-for="c in userCities"
              :key="c.id"
            >
              <button
                class="dropdown-item d-flex align-items-center gap-2"
                :class="{ active: selectedCityId === c.id }"
                type="button"
                @click="onSelectCity(c.id)"
              >
                <i class="bi bi-check2" :style="{ visibility: selectedCityId === c.id ? 'visible' : 'hidden' }"></i>
                {{ c.city_display_name }}
              </button>
            </li>
          </ul>
        </div>
        <!-- Если только один город — просто показываем название -->
        <span v-else-if="cityName" class="text-secondary small d-none d-sm-inline">
          <i class="bi bi-geo-alt-fill text-primary me-1"></i>{{ cityName }}
        </span>

        <!-- Погода -->
        <div v-if="weather" class="d-none d-md-flex align-items-center gap-2 text-secondary small">
          <i class="bi bi-cloud-sun fs-5"></i>
          <div>
            <div class="fw-semibold text-dark d-flex align-items-center gap-1">
              {{ Math.round(weather.temperature) }}°C
              <!-- Индикатор тренда температуры -->
              <span v-if="weather.temperature_trend" class="temperature-trend" :class="getTrendClass(weather.temperature_trend)" :title="getTrendTitle(weather.temperature_trend, weather.temperature_hour_ago)">
                <i :class="getTrendIcon(weather.temperature_trend)"></i>
              </span>
            </div>
            <div class="text-muted" style="font-size: 0.75rem; line-height: 1;">{{ weather.description }}</div>
          </div>
        </div>
      </div>

      <!-- ЦЕНТР: вкладки -->
      <ul class="navbar-nav mx-auto nav-underline gap-3">
        <li class="nav-item">
          <RouterLink class="nav-link d-inline-flex align-items-center gap-2"
                      :class="{ active: isActive('/') }"
                      to="/">
            <i class="bi bi-geo-alt"></i> Карта
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink class="nav-link d-inline-flex align-items-center gap-2"
                      :class="{ active: isActive('/report') }"
                      to="/report">
            <i class="bi bi-file-earmark"></i> Отчет
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink class="nav-link d-inline-flex align-items-center gap-2"
                      :class="{ active: isActive('/data') }"
                      to="/data">
            <i class="bi bi-card-text"></i> Исходные данные
          </RouterLink>
        </li>
        <!-- Все точки скрыты - функционал перенесен в Исходные данные -->
        <!-- <li class="nav-item">
          <RouterLink class="nav-link d-inline-flex align-items-center gap-2"
                      :class="{ active: isActive('/equipment') }"
                      to="/equipment">
            <i class="bi bi-list-ul"></i> Все точки
          </RouterLink>
        </li> -->
        <!-- ЛЭРС Учета скрыта по ТЗ -->
        <!-- <li class="nav-item">
          <RouterLink class="nav-link d-inline-flex align-items-center gap-2"
                      :class="{ active: isActive('/lers') }"
                      to="/lers">
            <i class="bi bi-gear"></i> ЛЭРС Учета
          </RouterLink>
        </li> -->
      </ul>

      <!-- ПРАВАЯ ЗОНА: уведомления + аватар -->
      <div class="d-flex align-items-center gap-3">
<!--        <RouterLink class="position-relative text-dark" to="/notifications" aria-label="Уведомления">-->
<!--          <i class="bi bi-bell fs-5"></i>-->
<!--          <span class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-white rounded-circle"></span>-->
<!--        </RouterLink>-->

        <div class="dropdown">
          <button class="btn btn-link p-0 d-flex align-items-center gap-1 text-decoration-none" data-bs-toggle="dropdown" type="button">
            <img :src="userAvatarUrl" alt="" class="rounded-circle" width="32" height="32">
            <i class="bi bi-caret-down-fill small text-dark"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><RouterLink class="dropdown-item" to="/profile">Профиль</RouterLink></li>
            <li><button class="dropdown-item" type="button" @click="logout">Выход</button></li>
          </ul>
        </div>
      </div>

    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { useRoute } from 'vue-router'
import ApiService from '@/services/api.service'

export default {
  name: 'AppHeader',
  data() {
    return {
      cityDropdown: null,
      weather: null,
    }
  },
  computed: {
    ...mapState({ currentUser: state => state.auth.user }),
    ...mapGetters({
      cityName: 'config/cityName',
      userCities: 'config/userCities',
      selectedCityId: 'config/selectedCityId',
    }),
    // Генерируем фиксированный аватар на основе username
    userAvatarUrl() {
      const username = this.currentUser?.username || this.currentUser?.email || 'U'
      const firstLetter = username.charAt(0).toUpperCase()
      const charCode = firstLetter.charCodeAt(0)
      const hue = (charCode * 7) % 360
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Crect width='40' height='40' fill='hsl(${hue}, 60%25, 55%25)'/%3E%3Ctext x='50%25' y='50%25' font-size='20' fill='white' text-anchor='middle' dy='0.35em' font-family='Arial, sans-serif' font-weight='bold'%3E${firstLetter}%3C/text%3E%3C/svg%3E`
    },
  },
  mounted() {
    // Загружаем погоду
    this.loadWeather()
    // Обновляем погоду каждые 30 минут
    this.weatherInterval = setInterval(() => {
      this.loadWeather()
    }, 30 * 60 * 1000)
  },
  beforeUnmount() {
    if (this.weatherInterval) {
      clearInterval(this.weatherInterval)
    }
  },
  methods: {
    async loadWeather() {
      try {
        const response = await ApiService.getCurrentWeather()
        this.weather = response.data
      } catch (error) {
        console.error('Error loading weather:', error)
        // Не показываем погоду если ошибка
        this.weather = null
      }
    },
    onSelectCity(cityId) {
      this.$store.dispatch('config/selectCity', cityId)
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => this.$router.push('/login'))
    },
    // Подсветка активной вкладки
    isActive(path) {
      const route = useRoute()
      return route.path === path
    },
    // Методы для индикатора тренда температуры
    getTrendClass(trend) {
      if (trend === 'up') return 'trend-up'
      if (trend === 'down') return 'trend-down'
      return 'trend-stable'
    },
    getTrendIcon(trend) {
      if (trend === 'up') return 'bi bi-arrow-up-circle-fill'
      if (trend === 'down') return 'bi bi-arrow-down-circle-fill'
      return 'bi bi-dash-circle-fill'
    },
    getTrendTitle(trend, tempHourAgo) {
      const trendText = trend === 'up' ? 'растет' : trend === 'down' ? 'падает' : 'стабильна'
      if (tempHourAgo !== null && tempHourAgo !== undefined) {
        return `Температура ${trendText} (час назад: ${Math.round(tempHourAgo)}°C)`
      }
      return `Температура ${trendText}`
    },
  },
}
</script>

<style scoped>
  /* логотип */
  .brand-logo { height: 32px; width: auto; display: block; }
  @media (max-width: 360px){ .brand-logo { height: 28px; } }

  /* меню выбора города */
  .city-menu {
    width: 280px;
    box-shadow:
      0 0 0 1px rgba(13,110,253,.18),
      0 18px 45px rgba(13,110,253,.35);
  }
  .city-list { max-height: 320px; overflow: auto; }
  .city-list .list-group-item.active {
    background-color: rgba(13,110,253,.08);
    color: #0d6efd;
    border-color: rgba(0,0,0,0.05);
  }
  .city-list .list-group-item:hover { background-color: rgba(33,37,41,.03); }

  /* вкладки */
  .nav-underline .nav-link { color:#212529; }
  .nav-underline .nav-link.active {
    color:#0d6efd;
    border-bottom-color:#0d6efd;
  }

  /* высота хедера */
  .navbar { min-height: 56px; }

  /* Индикатор тренда температуры */
  .temperature-trend {
    display: inline-flex;
    align-items: center;
    font-size: 0.9rem;
  }
  .temperature-trend.trend-up {
    color: #dc3545; /* красный для роста температуры */
  }
  .temperature-trend.trend-down {
    color: #0d6efd; /* синий для падения температуры */
  }
  .temperature-trend.trend-stable {
    color: #6c757d; /* серый для стабильной температуры */
  }
</style>
